import React, { Suspense, useContext } from "react";
import HeaderNew from "../HeaderNew";
import FooterNew from "../FooterNew";
import Footer from "../Footer";
import Loader from "../Loader";
import LoadingPage from "../loader/LoadingPage";
import MiniCasinoSheet from "../MiniCasinoSheet";
import AuthContext from "../../context/AuthContext";

const LayoutNew = ({ children, desktopHome = false }) => {
  const { showMiniCasino, setShowMiniCasino } = useContext(AuthContext);
  const Wrapper = desktopHome ? "div" : React.Fragment;
  const wrapperProps = desktopHome ? { className: "home-page-shell" } : {};
  return (
    <Wrapper {...wrapperProps}>
      <HeaderNew desktopHome={desktopHome} />
      <Suspense fallback={<LoadingPage />}>{children}</Suspense>
      <Loader />
      <Footer />
      <FooterNew />
      <MiniCasinoSheet
        open={showMiniCasino}
        onClose={() => setShowMiniCasino(false)}
      />
    </Wrapper>
  );
};

export default LayoutNew;
